import React from 'react';
import DeleteDialogView from './DeleteDialogView';

const GoalDeleteDialogView = props => (
  <DeleteDialogView
    {...props}
    title="Are you sure you want to delete this goal?"
    hint="You cannot undo this action."
  />
);

export default GoalDeleteDialogView;
